import { emptyArray } from '../../../../../../../../utils/arrayUtils';
import { formatToTitleCase } from '../../../../../../../../utils/helpers';
import { getFilterDisplayValue } from '../../../../helpers';

export const EXPIRATION_LABELS = {
  soonExpired: 'Expired Soon',
  expired: 'Expired',
  active: 'Active',
};

export function buildActiveFilterChips({ filterType, activeFilterMap, labels, handlers }) {
  const chips = [];

  if (filterType && filterType !== 'all' && EXPIRATION_LABELS[filterType]) {
    chips.push({
      key: 'type',
      name: labels.expirationStatus,
      value: EXPIRATION_LABELS[filterType],
      onDelete: handlers.removeExpiration,
    });
  }

  (activeFilterMap.setAsides?.value || []).forEach((item, index) => {
    chips.push({
      key: `setAsides-${index}`,
      name: labels.setAsides,
      value: formatToTitleCase(String(getFilterDisplayValue(item))),
      onDelete: () => handlers.removeListValue('setAsides', index),
    });
  });

  (activeFilterMap.naics?.value || []).forEach((item, index) => {
    chips.push({
      key: `naics-${index}`,
      name: labels.naics,
      value: formatToTitleCase(String(getFilterDisplayValue(item))),
      onDelete: () => handlers.removeListValue('naics', index),
    });
  });

  (activeFilterMap.state?.value || []).forEach((item, index) => {
    chips.push({
      key: `state-${index}`,
      name: labels.locations,
      value: formatToTitleCase(String(getFilterDisplayValue(item))),
      onDelete: () => handlers.removeListValue('state', index),
    });
  });

  (activeFilterMap.tags?.value || []).forEach((item, index) => {
    chips.push({
      key: `tags-${index}`,
      name: labels.tag,
      value: String(getFilterDisplayValue(item)),
      onDelete: () => handlers.removeListValue('tags', index),
    });
  });

  return chips;
}

export function removeFilterListValue(filtersState, key, index) {
  const nextFilters = { ...filtersState };
  const current = nextFilters[key]?.value;
  const value = emptyArray(current) ? [] : current.filter((_, i) => i !== index);

  if (emptyArray(value)) {
    delete nextFilters[key];
  } else {
    nextFilters[key] = { ...nextFilters[key], value };
  }

  return nextFilters;
}

export function createUpdatedListFilters(filters, updater) {
  const next = {
    ...filters,
    pagination: { ...filters.pagination, page: 1 },
    filters: { ...filters.filters },
  };
  updater(next);
  return next;
}
